import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const FacilityTrainingSetupNav = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/setup/booking`}>
				<ListItemText primary="Booking" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/setup/course_types`}>
				<ListItemText primary="Course Types" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/setup/locations`}>
				<ListItemText primary="Locations" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/setup/cancellation`}>
				<ListItemText primary="Cancellation" />
			</ListItem>
		</List>
	)
}

export default FacilityTrainingSetupNav
